import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataAsync, selectApp, setLastFocusedElement, setPage } from "../../app/appSlice";
import ListCategories from "../../components/ListCategories/ListCategories";
import Loading from "../../components/Loading/Loading";
// import { useHistory } from "react-router-dom";
import SpatialNavigation from "spatial-navigation-js";
import useSpatialNavigation from "../../useSpatialNavigation";

function Home() {
  const dispatch = useDispatch();
  const { isLoading, status, page } = useSelector(selectApp);
  const categoryListRef = useRef(null);
  
  useSpatialNavigation("middlebox", {enterTo: "last-focused", restrict: 'self-first', leaveFor: { up: '@upperbox' } });

  useEffect(() => {
    const fetchDataFromApi = async () => {
      try {
        const result = await dispatch(fetchDataAsync("/home.php"));
        dispatch(setPage({data: result, name: "Home"}));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if(!page.name || page.name !== "Home")
      fetchDataFromApi();
  }, [dispatch, page]);
  
  // Separate useEffect for spatial navigation
  useEffect(() => {
    SpatialNavigation.disable("watch-sidebar");
    SpatialNavigation.disable("middlebox-movies");
    SpatialNavigation.enable("middlebox");
    SpatialNavigation.focus("middlebox");
  
    return () => {
      SpatialNavigation.remove("middlebox");
    };
  }, []); // Empty dependency array ensures it runs only once on mount

  // Reset scroll to lastfocused on init
  useEffect(() => {
    if("Home" !== page.name || !window.location.href.includes("watch"))
      dispatch(setLastFocusedElement(null));
  },[dispatch, page.name]);

  // Prevent navigate back from this page & focus upperbox navbar
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      if(!window.location.href.includes("watch")) {
        SpatialNavigation.focus("upperbox");
        window.history.pushState(null, "", window.location.href);
      }      
    };
  
    // Initial fake state to trap user
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);
  
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);
  
  
  return (
    <div className="main-container">
      {isLoading && <Loading />}
      {status === "succeeded" && page.name === "Home" && (
        <ListCategories
          categoryListRef={categoryListRef}
          categories={page.data}
          spatialElementId="middlebox"
        />
      )}
      {status === "failed" && <p>Error loading data</p>}
    </div>
  );
}

export default Home;
